import { render } from "./PageFooter.vue?vue&type=template&id=0a9616e6"
const script = {}

import exportComponent from "/Users/cn7ero/workspace/timemarking/website/www.timemarking.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__